export function validatePassword(password: string) {
  if (password.length >= 8) {
    return true
  }

  return false;
}
